import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import {
  deleteWarningMsg,
  noInternetMsg,
  serverMsg,
} from "../../../config/messageconstant";
import { RateStructureColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import { withRouter } from "../../../components/withRouter";
import { stackHolderRateStructureDetailsJson } from "../../../DynamicFormsJson/MastersJSON/stackHolderRateStructureDetailsJson";
import {
  getproductRateStructure,
  getRateStructureAssignationByStockHolder,
} from "../../../Slice/productRateStructure.slice";
import ProductRateStructureViewPopupForStockHolder from "./ProductRateStructureViewPopupForStockHolder";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";

class StackHolderRateStructureDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPopup: false,
      viewData: "",
      DataToSet: [],
      fixedCalculation: "",
      dynamicMasterData: {},
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const {
      getRateStructureAssignationByStockHolder,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getRateStructureAssignationByStockHolder({
        stockStakeHolderId: this.props.params.id,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowView = (rowData) => {
    this.setState({
      viewPopup: true,
      viewData: rowData.productRateStructureId,
    });
  };

  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  backToList = () => {
    this.props.navigate(-1);
  };
  render() {
    const {
      dynamicMasterData,

      viewPopup,
      viewData,
      DataToSet,
      fixedCalculation,
    } = this.state;
    const {
      productRateStructureList,
      getRateStructureAssignationByStockHolder,
    } = this.props;
    {
      console.log(viewData);
    }
    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={"Stock Holder Rate Structure Details"}
            showSaveBtnMain={false}
            showAddButton={false}
            showBackButton={true}
            onCancel={this.backToList}
          />
          <DynamicMainScreen
            showViewButtonInTable={true}
            staticView={true}
            rowView={this.rowView}
            showDeleteIcon={true}
            dynamicMasterData={dynamicMasterData}
            formPath={stackHolderRateStructureDetailsJson.formPath}
            // screenTitle={false}
            formPathView={stackHolderRateStructureDetailsJson.formPathView}
            showPdfDownload={false}
            showExcelDownload={false}
            isActiveURL={stackHolderRateStructureDetailsJson.isActiveURL}
            showAddButton={false}
            tableColumns={RateStructureColumns}
            tableData={
              productRateStructureList.rateStructureAssignationStockHolder
            }
            apiBaseURL={stackHolderRateStructureDetailsJson.apiBaseURL}
            callApi={false}
            getTableDataById={true}
            showSearchBox={false}
            rowPDF={this.rowPDF}
            showPdf={false}
            showEditIcon={false}
            showPegination={false}
            getTableData={this.getData}
          />
        </Paper>

        {viewPopup && (
          <ProductRateStructureViewPopupForStockHolder
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            viewData={viewData}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  productRateStructureList: state.productRateStructure,
  productRateStructureAssignationList: state.productRateStructure,
});
const mapDispatchToProps = {
  getproductRateStructure,
  getRateStructureAssignationByStockHolder,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StackHolderRateStructureDetails);
